export enum WorkStatus {
  UNDEFINED = 0,
  ACTIVE = 1,
  STAFFED = 2,
  DONE = 3,
  DELETED = 4,
}
